import { initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, RemoteConfig } from 'firebase/remote-config';
import { appStore } from '@store';

interface RemoteConfigWithStorageCache extends RemoteConfig {
	_storageCache: any;
}

declare global {
	interface Window {
		firebaseConfigData: any;
	}
}

export default function () {
	const firebaseConfig = {
		apiKey: 'AIzaSyDXTQ_D8NZaW4ipPp15dt-7wFnJjNHY7Fg',
		authDomain: 'verv-web.firebaseapp.com',
		projectId: 'verv-web',
		storageBucket: 'verv-web.appspot.com',
		messagingSenderId: '216739999947',
		appId: '1:216739999947:web:398731ed929cb1995c2b4e',
	};

	const app = initializeApp(firebaseConfig);
	const remoteConfig = getRemoteConfig(app) as RemoteConfigWithStorageCache;
	remoteConfig.settings.minimumFetchIntervalMillis = 15000;

	remoteConfig.defaultConfig = {
		discountBlockV1: 'discountBlockV1_a',
		paymentMethod_1: 'paymentMethod_1_a',
		payPal: 'payPal_a',
		walkingDesignV1Payment: 'walkingDesignV1Payment_a',
	};

	fetchAndActivate(remoteConfig)
		.then(() => {
			if (remoteConfig._storageCache.activeConfig) {
				checkRemoteConfigValue(remoteConfig._storageCache.activeConfig);
			} else {
				checkRemoteConfigValue(remoteConfig.defaultConfig);
			}
		})
		.catch(err => {
			console.log(err);
			checkRemoteConfigValue(remoteConfig.defaultConfig);
		});

	function checkRemoteConfigValue(params: any) {
		window.firebaseConfigData = params;
		console.log(window.firebaseConfigData);

		setTimeout(() => {
			sendABTestEvent();
		}, 2000);

		if (
			window.firebaseConfigData &&
			window.firebaseConfigData.discountBlockV1 === 'discountBlockV1_b'
		) {
			localStorage.setItem('discountBlockV1', 'discountBlockV1_b');
		}
	}

	function sendABTestEvent() {
		const { walkingDesignV1 } = appStore.paymentStore.settings;
		const walkingDesignV1Payment =
			window.firebaseConfigData &&
			window.firebaseConfigData.walkingDesignV1Payment === 'walkingDesignV1Payment_b';

		if (walkingDesignV1 && walkingDesignV1Payment) {
			window.dataLayer.push({
				event: 'AB_TEST',
				ab_name: 'payment_screen_walking_v1',
				ab_group: 'B',
				ab_test_type: 'quiz',
			});
		}

		if (!walkingDesignV1 || !walkingDesignV1Payment) {
			window.dataLayer.push({
				event: 'AB_TEST',
				ab_name: 'payment_screen_walking_v1',
				ab_group: 'A',
				ab_test_type: 'quiz',
			});
		}
	}

	console.log('firebaseConfig enabled');
}
